import React from 'react';

export const ConnectionIcon = ({ src, width = '24px', height = '24px' }) => (
	<img
		src={src}
		style={{ height, width, backgroundColor: 'white', borderRadius: '4px', border: '1px solid white' }}
	/>
);
